import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useMemo } from 'react';

const EventPathContext = createContext({
  eventPathNames: []
});
const EventPathBoundary = ({
  eventPathName,
  children
}) => {
  const upperEventPaths = useContext(EventPathContext).eventPathNames;
  const value = useMemo(
    () => ({ eventPathNames: [...upperEventPaths, eventPathName] }),
    [eventPathName, upperEventPaths]
  );
  return /* @__PURE__ */ jsx(EventPathContext.Provider, { value, children });
};
const useEventPathBoundary = () => {
  return useContext(EventPathContext);
};

export { EventPathBoundary, EventPathContext, useEventPathBoundary };
//# sourceMappingURL=eventPathBoundary.mjs.map
